import { onError } from "apollo-link-error";
import { fromPromise } from "apollo-link";
import promiseFinally from "p-finally";
import { refreshAccessToken, unauthenticate } from "@/lib/auth";
import { isProduction } from "@/utils/constants";
import EventBus from "@/lib/event-bus.js";

let isRefreshing = false;
let pendingRequests = [];

const resolvePendingRequests = () => {
  pendingRequests.map((callback) => callback());
  pendingRequests = [];
};

const link = (storeAccessToken) => {
  return onError(({ graphQLErrors, networkError, operation, forward }) => {
    if (graphQLErrors) {
      for (let err of graphQLErrors) {
        switch (err.errorType) {
          case "UnauthorizedException":
            // error code is set to UnauthorizedException
            // when AuthenticationError thrown in resolver
            let forward$;

            if (!isRefreshing) {
              isRefreshing = true;

              forward$ = fromPromise(
                promiseFinally(
                  refreshAccessToken()
                    .then((accessToken) => {
                      // Update local storage new token...
                      storeAccessToken(accessToken);

                      resolvePendingRequests();

                      return accessToken;
                    })
                    .catch((error) => {
                      pendingRequests = [];
                      // Handle token refresh errors e.g clear stored tokens, redirect to login, ...

                      // Pass isProduction as the redirect parameter to handle whether we redirect the user to the login page or not
                      // We redirect in production but not devs as to show the login modal below
                      unauthenticate(isProduction);

                      // If on devs show the login modal...
                      if (!isProduction) {
                        EventBus.$emit("show-login-modal", {
                          title: "Your session has expired.",
                          message: "Please login again then retry.",
                        });
                      }

                      return;
                    }),
                  () => {
                    // on finally, we use p-finally lib to support IE11/Edge
                    isRefreshing = false;
                  }
                )
              ).filter((value) => Boolean(value));
            } else {
              // Will only emit once the Promise is resolved
              forward$ = fromPromise(
                new Promise((resolve) => {
                  pendingRequests.push(() => resolve());
                })
              );
            }

            return forward$.flatMap(() => forward(operation));
        }
      }
    }

    if (networkError) {
      // Send an event to the app to show a dropdown banner that the user is experiencing network issues...
      const statusCode = networkError?.statusCode;

      if (statusCode !== 401) {
        EventBus.$emit("network-error");
      }

      console.log(`📴Network error: ${networkError}`);
    }
  });
};

export default link;
